class StoreAvailability {
  constructor(el) {
    this.el = el;
    this.api = el.dataset.api;
    this.apiKey = el.dataset.apiKey;
    this.list = el.querySelector('.store-av__list');
    this.fetch(el.dataset.sku);

    document.addEventListener('product:variant-change', (e) => {
      const sku = e.detail?.variant?.sku;
      if (sku) this.fetch(sku);
    });
  }

  async fetch(sku) {
    this.list.innerHTML = '<p class="store-av__loading">Cargando disponibilidad...</p>';
    try {
      const url = `${this.api}?sku=${encodeURIComponent(sku)}&api_key=${this.apiKey}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error();
      const tiendas = await res.json();
      this.render(tiendas);
    } catch {
      this.list.innerHTML = '<p class="store-av__error">No se pudo cargar la disponibilidad.</p>';
    }
  }

  getIconClass(estadoClase) {
    return estadoClase === 'unavailable' ? 'store-av__icon store-av__icon--unavailable' : 'store-av__icon';
  }

  getStockLabel(t) {
    if (!t.disponible) return 'Sin stock';
    return `${t.cantidad} disponible${t.cantidad !== 1 ? 's' : ''}`;
  }

  render(tiendas) {
    if (!tiendas.length) {
      this.list.innerHTML = '<p class="store-av__loading">Sin información de stock.</p>';
      return;
    }

    this.list.innerHTML = tiendas.map(t => `
      <div class="store-av__item">
        <div class="${this.getIconClass(t.estado_clase)}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
            <circle cx="12" cy="9" r="2.5"/>
          </svg>
        </div>
        <div class="store-av__body">
          <div class="store-av__top">
            <span class="store-av__name">${t.tienda}</span>
            <span class="store-av__badge store-av__badge--${t.estado_clase}">${t.estado_texto}</span>
          </div>
          ${t.direccion ? `<div class="store-av__address">${t.direccion}</div>` : ''}
          ${t.telefono ? `<div class="store-av__phone">${t.telefono}</div>` : ''}
          <div class="store-av__stock">
            <span class="store-av__dot store-av__dot--${t.estado_clase}"></span>
            ${this.getStockLabel(t)}
          </div>
        </div>
      </div>
    `).join('');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.store-av');
  if (el) new StoreAvailability(el);
});